import ReduxProvider from 'store/Provider'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'

import HeadComponent from './Head'
import AnalyticsComponent from './Analytics'
import LanguageHandler from 'components/language/LanguageHandler'
import SchoolLoader from 'components/school/SchoolLoader'
import AuthorizationHandler from 'components/authorization/AuthorizationHandler'
import AppFlowHandler from 'components/app-flow/AppFlowHandler'
import HistoryHandler from 'components/history/HistoryHandler'
import SessionHandler from 'components/session/SessionHandler'
import MuiThemeProvider from 'theme/MuiThemeProvider'

import UserLoader from 'components/user/UserLoader'
import AlertWrapper from 'components/alert/AlertWrapper'
import EmailOptInModal from 'components/modals/EmailOptInModalConnector'
import CrisisModal from 'components/modals/CrisisModalConnector'
import MainWrapper from 'components/main-wrapper/MainWrapper'
import AppRoutes from 'routes/AppRoutes'

const App = () => (
  <ReduxProvider>
    <HelmetProvider>
      <HeadComponent />
      <AnalyticsComponent />
      <LanguageHandler>
        <SchoolLoader />
        <MuiThemeProvider>
          <BrowserRouter>
            <HistoryHandler />
            <SessionHandler />
            <AuthorizationHandler />
            <AppFlowHandler />
            <AlertWrapper />
            <CrisisModal />
            <EmailOptInModal />
            <UserLoader />
            <MainWrapper>
              <AppRoutes />
            </MainWrapper>
          </BrowserRouter>
        </MuiThemeProvider>
      </LanguageHandler>
    </HelmetProvider>
    <script defer src="https://accounts.google.com/gsi/client" />
  </ReduxProvider>
)

export default App
